import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const slideInTop = trigger('slideInTop', [
  state(
    'void',
    style({
      opacity: 0,
      height: 0,
    })
  ),
  state(
    'enter',
    style({
      opacity: 1,
      height: '*',
    })
  ),
  transition(':enter', [animate('200ms linear')]),
  transition(':leave', [animate('200ms linear')]),
]);

export const slideInTopOpenClose = trigger('slideInTopOpenClose', [
  state(
    'void',
    style({
      opacity: 0,
      height: 0,
    })
  ),
  state(
    'open',
    style({
      opacity: 1,
      height: '*',
    })
  ),
  state(
    'open-instant',
    style({
      opacity: 1,
      height: '*',
    })
  ),
  transition('void <=> open', [animate('200ms linear')]),
  // transition('close <=> *', [animate('200ms linear')]),
]);
